import { Box, Button, Tooltip } from '@mui/material';
import * as React from 'react';

import { DISABLED_SUBMIT_BUTTON_HINT } from '../../../../constants/oneLink';

import variables from '../../../../contexts/ThemeProvider/variables';

interface IProps {
  onCancel: () => void;
  onSubmit?: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  customText?: string;
  submitDataAction?: string;
}

export const FormControls: React.FC<IProps> = ({
  onCancel,
  onSubmit,
  customText,
  submitDataAction,
  isDisabled,
  isLoading,
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
      <Button variant="text" size="medium" onClick={onCancel} sx={{ width: 150, ml: 2 }} disabled={isLoading}>
        Cancel
      </Button>
      <Tooltip title={isDisabled ? DISABLED_SUBMIT_BUTTON_HINT : ''} arrow placement="top-start">
        <span>
          <Button
            type="submit"
            loading={isLoading}
            variant="contained"
            size="medium"
            disabled={isDisabled}
            sx={{ width: 150, ml: 2, color: variables.white }}
            onClick={onSubmit ? onSubmit : undefined}
            data-action={submitDataAction}
          >
            {customText || 'Save'}
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};
